const modules = [
    {
        preLoad: () => {
            window._gt = window._gt || [];
            window._gt.push([
                'config',
                {
                    debug: false,
                    dslResource: 'https://gchat.orange.pl/server/resources/dsl/domain-model.xml',
                    httpEndpoint: 'https://gchat.orange.pl',
                    httpsEndpoint: 'https://gchat.orange.pl'
                }
            ]);

            window._genesys = {
                debug: false,
                chat: false,
                cobrowse: false,
                integration: { buttons: { chat: false, cobrowse: false } }
            };
        },
        id: '_gt',
        url: '/GTCJ.min.js'
    },
    {
        id: 'opl-wc-polyfills',
        url: '/opl-wc-polyfills.js'
    },
    {
        id: 'opl-wc-vendors',
        url: '/opl-wc-vendors.js'
    },
    {
        id: 'opl-wc-parent',
        url: '/opl-wc-parent.js'
    },
    {
        id: 'opl-wc-closer',
        url: '/opl-wc-closer.js',
        callback: () => document.dispatchEvent(new CustomEvent('WCCloserLoaded'))
    }
];

export default modules;
